<app-infinity-scroll
  [isErrorScroll]="emailsScrollService.isErrorScroll()"
  [isLoadingScroll]="emailsScrollService.isLoadingScroll()"
  [canNavigateForward]="emailsScrollService.canNavigateForward()"
  (loadData)="emailsService.onScroll()"
  (refreshData)="emailsService.loadData(false, false, false)"
  [dataLength]="emailsPageStateService.dataSource.data.length"
  class="table-container-hover">
  <table
    mat-table
    [dataSource]="emailsPageStateService.dataSource"
    class="table-row-hover"
    matSort
    matSortDisableClear
    [matSortActive]="emailsPageStateService.defaultSortOrder()"
    [matSortDirection]="emailsPageStateService.defaultOrderDirection()"
    (matSortChange)="sortData.emit($event)"
    [trackBy]="trackById">
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell"
        [attr.colspan]="emailsPageStateService.displayedColumns.length">
        <div class="table-row">
          {{ 'noEmailsEmailsContentComponent' | translate }}
        </div>
      </td>
    </tr>
    <ng-container [matColumnDef]="EmailColumnsEnum.Select">
      <th mat-header-cell *matHeaderCellDef style="min-width: 40px; padding: 0">
        <app-email-all-select-checkbox />
      </th>
      <td style="min-width: 40px; padding: 0" mat-cell *matCellDef="let row">
        <app-email-select-checkbox [emailId]="row.emailId" />
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.ArchiveStatus">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="min-width: 40px; padding: 0"></th>
      <td style="min-width: 40px; padding: 0" mat-cell *matCellDef="let row">
        <app-archive-state-cell [email]="row" />
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Starred">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="min-width: 40px; padding: 0"></th>
      <td style="min-width: 40px; padding: 0" mat-cell *matCellDef="let row">
        <app-star-button
          [iconFull]="row.isStarred"
          [showLoading]="row.isStarredLoading"
          (click)="actions.addEmailToStar(row.emailId)" />
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Reply">
      <th
        style="min-width: 40px; padding: 0"
        mat-header-cell
        *matHeaderCellDef></th>
      <td style="min-width: 40px; padding: 0" mat-cell *matCellDef="let email">
        <div
          [ngClass]="{
            button: !!email?.replyDateTime,
            'button-waiting': !email?.replyDateTime,
          }"
          class="flex w-full items-center justify-center">
          @if (email.replyType) {
            <mat-icon
              matTooltip="{{
                email.replyType | emailReply: !!email?.replyDateTime | translate
              }}">
              {{ replyIcons[email.replyType] }}
            </mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Attachment">
      <th
        style="min-width: 40px; padding: 0"
        mat-header-cell
        *matHeaderCellDef></th>
      <td style="min-width: 40px; padding: 0" mat-cell *matCellDef="let email">
        @if (email.hasAttachments) {
          <button
            class="hover-disabled"
            mat-icon-button
            [attr.aria-label]="'attachment' | translate"
            matTooltip="{{ 'attachment' | translate }}">
            <mat-icon>attachment_outline</mat-icon>
          </button>
        }
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Notes">
      <th mat-header-cell *matHeaderCellDef></th>
      <td *matCellDef="let email" mat-cell>
        <div class="flex gap-1">
          <app-notes-button
            (click)="actionsModals.openNotes(email.emailId)"
            [hasCount]="!!email.notesCount" />

          @if (email.showMeta) {
            <app-meta-button (click)="actionsModals.openMeta(email.emailId)" />
          }
          @if (email.needsEmptyPlaceholder) {
            <div class="w-[40px]"></div>
          }
        </div>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.To">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [class.first-row]="emailsPageStateService.isFirstRowTo()">
        {{ 'tableRowHeaderTo' | translate }}
      </th>
      <td
        [class.first-row-content]="emailsPageStateService.isFirstRowTo()"
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer"
        matTooltip="{{ email.to | formatSemicolon }}"
        (mousedown)="startRecording.emit($event)"
        (mouseup)="finishRecording.emit({ event: $event, email })">
        <div class="to-limitation">
          {{ email.to | formatSemicolon }}
        </div>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.From">
      <th
        mat-header-cell
        mat-sort-header
        [class.first-row]="emailsPageStateService.isFirstRowFrom()"
        *matHeaderCellDef>
        {{ EmailColumnsEnum.From | translate }}
      </th>
      <td
        [class.first-row-content]="emailsPageStateService.isFirstRowFrom()"
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer"
        (mousedown)="startRecording.emit($event)"
        (mouseup)="finishRecording.emit({ event: $event, email })">
        {{ email.from | formatSemicolon }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Subject">
      <th
        style="width: 100%; min-width: 200px"
        mat-header-cell
        *matHeaderCellDef>
        {{ EmailColumnsEnum.Subject | translate }}
      </th>
      <td
        style="width: 100%; min-width: 200px"
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer"
        (mousedown)="startRecording.emit($event)"
        (mouseup)="finishRecording.emit({ event: $event, email })">
        {{ email.subject }}
        <app-email-tags [tags]="email.tags" />
        @if (!!email?.groups?.length) {
          <app-email-group-list [groups]="email.groups" />
        }
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Size">
      <th mat-header-cell style="min-width: 100px" *matHeaderCellDef>
        {{ EmailColumnsEnum.Size | translate }}
      </th>
      <td mat-cell style="min-width: 100px" *matCellDef="let email">
        {{ email.totalSize | formatSize: 2 }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Source">
      <th
        [class.source-table]="emailsPageStateService.hasSourceColumn()"
        mat-header-cell
        *matHeaderCellDef>
        {{ 'sourceTableRow' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let email"
        [class.source-table]="emailsPageStateService.hasSourceColumn()"
        class="cursor-pointer"
        (click)="actionsModals.emailDetails(email)">
        {{ email.dataSourceColumn | translate }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Meta">
      <th
        [class.source-table]="emailsPageStateService.isMailFolderTypeOutbox()"
        class="w-fit"
        mat-header-cell
        *matHeaderCellDef>
        {{ EmailColumnsEnum.Meta | translate }}
      </th>
      <td
        [class.source-table]="emailsPageStateService.isMailFolderTypeOutbox()"
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer">
        <div class="flex">
          @if (email?.hasRetrySending) {
            <app-retry-sending-button
              (click)="actions.retrySend(email.emailId)" />
          }
          @if (email?.hasMoveToDraft) {
            <app-move-to-draft-button
              (click)="actions.moveToDraft(email.emailId)" />
          }
          @if (email?.hasMeta) {
            <app-meta-button (click)="actionsModals.openMeta(email.emailId)" />
          }
        </div>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Folder">
      <th class="source-table" mat-header-cell *matHeaderCellDef>
        {{ EmailColumnsEnum.Folder | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let email"
        class="source-table cursor-pointer"
        (click)="actionsModals.emailDetails(email)">
        {{ email?.folderName | translate }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.Date">
      <th
        style="min-width: 170px"
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef>
        {{ EmailColumnsEnum.Date | translate }}
      </th>
      <td
        style="min-width: 170px"
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer">
        {{ email.date | date: 'dd/MM/yyyy HH:mm:ss' }}
        <app-email-action-buttons
          [ngClass]="emailsPageStateService.styleContainerHoverMenu()"
          class="right-hover-menu"
          [email]="email" />
      </td>
    </ng-container>
    <ng-container [matColumnDef]="EmailColumnsEnum.State">
      <th
        mat-header-cell
        *matHeaderCellDef
        [style]="
          emailsPageStateService.isMailFolderTypeOutbox()
            ? 'min-width: 200px'
            : 'min-width: 100px'
        ">
        {{ EmailColumnsEnum.State | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let email"
        class="cursor-pointer"
        [style]="
          emailsPageStateService.isMailFolderTypeOutbox()
            ? 'min-width: 200px'
            : 'min-width: 100px'
        ">
        @if (!emailsPageStateService.isMailFolderTypeOutbox()) {
          <app-sending-state-button
            [state]="sendingIcons?.[email?.sendingStatus]"
            (click)="actionsModals.openNotifications(email.emailId)" />
        } @else {
          <ng-container>
            {{ ('emailState' + EmailState[email.state]) | translate }}
          </ng-container>
        }
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="
        emailsPageStateService.displayedColumns;
        sticky: true
      "></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: emailsPageStateService.displayedColumns"
      [ngClass]="{
        '!font-bold': !row.seen,
        'row-select': emailsPageStateService.selection.isSelected(row.emailId),
        'row-automatic-reassigned': !!row?.isRowAutoReassigned,
        'row-error': !!row?.isRowWithError,
        'row-new-email': row?.newEmail,
      }"
      (contextmenu)="rightClick.emit({ event: $event, email: row })"></tr>
  </table>
</app-infinity-scroll>
